<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false">Close</v-btn>
        </v-snackbar>
        <ClientNav/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-data-table
                    :headers="headers"
                    :items="allergies"
                    sort-by="Allergy"
                    sort-asc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Allergies..."
                    :search="search"
                    height="578"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Allergies</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="Search"
                                class="flex-grow-1"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                            <v-btn color="#2b3990" dark @click="showAdd()">
                                <v-icon left>add</v-icon>
                                <span class="hidden-sm-and-down">Add Allergy</span>
                                <span class="hidden-md-and-up">Add</span>
                            </v-btn>
                            <v-btn class="primary" @click="printTable()">
                                <v-icon small>print</v-icon>
                                <span class="hidden-sm-and-down">Print</span>
                            </v-btn>
                        </v-toolbar>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-2" @click="viewAllergy(item)">
                            mdi-eye
                        </v-icon>
                        <v-icon small @click="deleteAllergy(item)">mdi-delete</v-icon>
                    </template>
                    <template v-slot:no-data>
                        <v-btn color="#2b3990" class="white--text" @click="getAllergies()">Reset</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <report-table
            :reportHeaderText="reportHeaderText"
            :tableHeaders="reportTableHeader"
            :tableData="reportData"
        />
    </div>

</template>

<script>
import axios from "axios";
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import Foot from "../components/Footer";
import ReportTable from '@/components/Report/ReportTable.vue';

const url = require("../client_config/config").url;

export default {
  components: {
      Foot,
      ClientNav,
      ClientSide,
      ReportTable
  },
  data: function () {
      return {
          headers: [
              {
                  text: "Allergy",
                  align: "start",
                  sortable: false,
                  value: "Allergy",
              },
              {text: "Actions", value: "actions", sortable: false},
          ],
          msg: false,
          search: "",
          text: "",
          allergies: [],
          clientID: this.$route.params.clientID,
          titleForm: "New Allergy",
          allergyID: "",
          newAllergy: "",
          isLoading: true,
      };
  },

  computed: {
      reportHeaderText() {
          return 'Allergies';
      },
      reportData() {
          return this.allergies
      },
      reportTableHeader() {
          return this.headers.slice(0, this.headers.length-1);
      }
  },

  watch: {
      dialog(val) {
          val || this.close();
      },
  },

  created() {
      this.getAllergies();
  },

  methods: {
      initialize() {
          this.allergies = [];
      },

      viewAllergy(item) {
          this.$router.push({
              path: `/allergies/${this.clientID}/update/${item._id}`,
              query: {createAllergy: false}});
      },

      showAdd() {

          this.$router.push({
              path: `/allergies/${this.clientID}/new`,
              query: {createAllergy: true}});
      },

      deleteAllergy(item) {
          const id = item._id;
          confirm("Are you sure you want to delete this allergy?") &&
          this.allergyDelete(id);
      },

      allergyDelete(id) {
          axios.delete(`${url}/allergies/${id}`).then((response) => {
              this.getAllergies();
              if (response.status === 400) {
                  response.json().then(function (data) {
                      return data.msg;
                  });
              }
              this.msg = true;
              this.text = "The allergy has been deleted successfully.";
          });
      },

      close() {
          this.newAllergy = "";
          this.dialog = false;
          this.$nextTick(() => {
              this.editedItem = Object.assign({}, this.defaultItem);
              this.editedIndex = -1;
          });
      },

      getAllergies: function () {
          this.isLoading = true;
          axios
              .get(`${url}/allergies/allergy`, {
                  params: {
                      ClientId: this.clientID,
                  },
              })
              .then((res) => {
                  this.allergies = res.data.allergies;
              })
              .finally(() => (this.isLoading = false));
      },

      printTable() {
          document.getElementById('printTable').style.display = "block";
          window.print()
          document.getElementById('printTable').style.display = "none";
      }
  },
};
</script>

<style>
#printTable{
  display: none;
}

@media print {
  #printTable {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  .hideOnPrint {
    display: none;
    border: none;
  }

  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none;

  }

  @page { margin: 0; }
  body { margin: 1.6cm; }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
    .mobile {
        display: block;
    }
}

@media only screen and (min-width: 601px) {
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
}

</style>
